var React = require('react');

function BgTriangle1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M223 203.309L329.622 0.00488281L467 331.005L223 203.309Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M0 203.005L330 0.00488281L223.416 203.005H0Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M0 203.005H223.259L467 331.005L0 203.005Z","fill":"#5915C7","key":2})]);
}

BgTriangle1.defaultProps = {"width":"467","height":"332","viewBox":"0 0 467 332","fill":"none"};

module.exports = BgTriangle1;

BgTriangle1.default = BgTriangle1;
